let api_base;
if(process.env.NODE_ENV === 'production'){
    api_base = 'https://api.benolsam.gov.tr/';
}else{
    api_base = 'http://localhost:3000/';
}
export const api_base_url = api_base;